import axiosInstance from './axiosConfig';
import { AxiosResponse } from 'axios';
import { generateBFFUrl } from '@/configs/apiEndPoints';
import { ERROR } from '@/configs/constants';
import { GenericError } from '@/errors/GenericServerError';
import dlv from 'dlv';
import { STATES_LIST, CITIES_LIST, STORE_LOCATIONS, SERVICE_CENTERS } from '@/configs/ecom/apis'; // Assuming they are defined here
import seoResponseTransform from '@/utils/seoResponseTransform';

export const fetchStates = async (type: string): Promise<any> => {
  try {
    const response = await axiosInstance.get(generateBFFUrl(STATES_LIST), {
      params: {
        // populate: 'attributes',
        'filters[eflStoreLocations][type][$eq]': type,
      },
    });
    return dlv(response, 'data.data', []);
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};

export const fetchCities = async (stateId: string, type: string): Promise<any> => {
  try {
    const response = await axiosInstance.get(generateBFFUrl(`${CITIES_LIST}/${stateId}/${type}`), {
      params: {
        // populate: 'attributes',
      },
    });
    return dlv(response, 'data.data', []);
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};

export const fetchLocations = async (
  type?: any,
  stateId?: string,
  cityId?: string,
): Promise<any> => {
  try {
    const params = {
      populate: 'city',
      type,
      stateId,
      cityId,
    };

    const response = await axiosInstance.get(generateBFFUrl(STORE_LOCATIONS), {
      params,
    });

    return response.data;
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};

export const fetchServiceCentres = async (type: string, locationId: string): Promise<any> => {
  try {
    const params = {
      populate: '*',
      type,
      locationId,
    };

    const response = await axiosInstance.get(
      generateBFFUrl(`${SERVICE_CENTERS}/${type}/${locationId}`),
      {
        params,
      },
    );

    const data = dlv(response, 'data.data.attributes', {});
    seoResponseTransform(data.seo);
    return data;
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};
